// extracted by mini-css-extract-plugin
module.exports = {"customerItem":"profilecustomer_customerItem__339jT","customerItemIcon":"profilecustomer_customerItemIcon__2LEsN","customerItemActive":"profilecustomer_customerItemActive__2TnGT"};